export const SET_USER = "SET_USER";
export const REMOVE_USER = "REMOVE_USER";

export const SAGA_SET_USER = "SAGA_SET_USER";

export class Saga {
  static setUser() {
    return {
      type: SAGA_SET_USER
    }
  };
}

export class Generator {
  static setUser(user) {
    return {
      type: SET_USER,
      user
    }
  };
  static removeUser() {
    return {
      type: REMOVE_USER
    }
  };
}